import { render, staticRenderFns } from "./AudienceView.vue?vue&type=template&id=68416423"
import script from "./AudienceView.vue?vue&type=script&lang=js"
export * from "./AudienceView.vue?vue&type=script&lang=js"
import style0 from "./AudienceView.vue?vue&type=style&index=0&id=68416423&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports